import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';
import Grow from '@material-ui/core/Grow';
import {
  stableSort,
  getSorting
} from './utils/sort';
import { viewTitleStyle } from './constants';

function createData(draws) {
  //TODO validate results
  return draws.map((d) => {
    return {
      id: d.drawDate, 
      date: d.drawDate, 
      numbers: getNumbersString(d.numbers), 
      powerball: d.powerball,
      powerplay: d.powerplay ? d.powerplay : 'N/A'
    }
  });
}

function getNumbersString(numbers) {
  return numbers[0] + ", " + numbers[1] + ", " + numbers[2] + ", " + numbers[3] + ", " + numbers[4]
}

const rows = [
  {
    id: 'date',
    label: 'Draw Date'
  }, {
    id: 'numbers',
    label: 'Winning Numbers'
  }, {
    id: 'powerball',
    label: 'PowerBall'
  }, {
    id: 'powerplay',
    label: 'Power Play'
  }
];

const tableHeadStyles = theme => ({
  headCell: {
    textAlign: 'left',
    padding: '0 0 0 20px',
    fontWeight: '400',
  },
  headCellSortLabel: {
  }
});

class EnhancedTableHead extends React.Component {
  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const {classes, order, orderBy} = this.props;
    return (<TableHead>
      <TableRow>
        {
          rows.map(row => {
            return (<TableCell className={classes.headCell} key={row.id} sortDirection={orderBy === row.id
                ? order
                : false}>
              <Tooltip title="Sort" placement={'bottom-end'} enterDelay={300}>
                <TableSortLabel className={classes.headCellSortLabel} active={orderBy === row.id} direction={order} onClick={this.createSortHandler(row.id)}>
                  {row.label}
                </TableSortLabel>
              </Tooltip>
            </TableCell>);
          }, this)
        }
      </TableRow>
    </TableHead>);
  }
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired
};

EnhancedTableHead = withStyles(tableHeadStyles)(EnhancedTableHead);

const toolbarStyles = theme => ({
  spacer: {
    flex: '0 0 100%'
  },
  actions: {
    color: theme.palette.text.secondary
  },
  title: viewTitleStyle, 
  dataCell: {
    textAlign: 'left',
    padding: '0'
  }
});

let EnhancedTableToolbar = props => {
  const {classes, draws} = props;

  return (
    <div>
      <h1 className={classes.title}>
        All {draws.length} Winning Draws From {draws[draws.length - 1]['drawDate']} To {draws[0]['drawDate']}
      </h1>
      <div className={classes.spacer}/>
    </div>);
};

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired
};

EnhancedTableToolbar = withStyles(toolbarStyles)(EnhancedTableToolbar);

const styles = theme => ({
  root: {
    margin: '10px 15px 0 auto',
    padding: '10px',
    width: '530px',
    boxSizing: 'border-box',
  },
  table: {
    minWidth: '380px'
  },
  tableWrapper: {
    overflowX: 'auto'
  }, 
  dataCell: {
    textAlign: 'left',
    padding: '0 0 0 20px'
  }
});

class EnhancedTable extends React.Component {

  state = {
    order: 'desc',
    orderBy: 'date',
    data: createData(this.props.draws),
    page: 0,
    rowsPerPage: 5,
    draws: this.props.draws
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({order, orderBy});
  };

  handleChangePage = (event, page) => {
    this.setState({page});
  };

  handleChangeRowsPerPage = event => {
    this.setState({rowsPerPage: event.target.value});
  };

  render() {
    const {classes} = this.props;
    const {data, order, orderBy, rowsPerPage, page} = this.state;
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);
    return (
      <Grow in={true}>
        <Paper className={classes.root}>
          <EnhancedTableToolbar draws={this.state.draws}/>
          <hr/>
          <div className={classes.tableWrapper}>
            <Table className={classes.table} aria-labelledby="tableTitle">
              <EnhancedTableHead order={order} orderBy={orderBy} onRequestSort={this.handleRequestSort} rowCount={data.length} draws={this.state.draws}/>
              <TableBody>
                {
                  stableSort(data, getSorting(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(d => {
                    return (                  
                      <TableRow hover={true} tabIndex={-1} key={d.id}>
                        <TableCell className={classes.dataCell} component="th" scope="row">
                          {d.date}
                        </TableCell>
                        <TableCell className={classes.dataCell}>{d.numbers}</TableCell>
                        <TableCell className={classes.dataCell}>{d.powerball}</TableCell>
                        <TableCell className={classes.dataCell}>{d.powerplay}</TableCell>
                      </TableRow>);
                  })
                }
                {
                  emptyRows > 0 && (<TableRow style={{
                      height: 49 * emptyRows
                    }}>
                    <TableCell colSpan={3}/>
                  </TableRow>)
                }
              </TableBody>
            </Table>
          </div>
          <TablePagination rowsPerPageOptions={[5, 20, 100, this.state.draws.length]} component="div" count={data.length} rowsPerPage={rowsPerPage} page={page} backIconButtonProps={{
              'aria-label' : 'Previous Page'
            }} nextIconButtonProps={{
              'aria-label' : 'Next Page'
            }} onChangePage={this.handleChangePage} onChangeRowsPerPage={this.handleChangeRowsPerPage}/>
        </Paper>
      </Grow>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(EnhancedTable);
